import { Card, Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Rating from '../Rating/Rating'
import './product.css'

const Product = ({ product }) => {
  return (
    <Card className="product-card">
      <Link to={`/product/${product._id}`} className="product-image-link">
        <Card.Img src={product.image} variant="top" />
        <Badge className="product-badge">Curated</Badge>
      </Link>
      <Card.Body>
        <Link to={`/product/${product._id}`} className="product-name-link">
          <Card.Title as="div" className="product-title">
            <strong>{product.name}</strong>
          </Card.Title>
        </Link>
        <Card.Text as="div">
          <Rating
            value={product.rating}
            text={`${product.numReviews} reviews`}
          />
        </Card.Text>

        <div className="product-meta-row">
          <Card.Text as="h3" className="product-price">
            ${product.price}
          </Card.Text>
          <span className="product-cta">View</span>
        </div>
      </Card.Body>
    </Card>
  )
}

export default Product
